import type { PredefinedSize } from "@/types/theme";

export function getSizeByPredefinedSize(size: PredefinedSize) {
  if (!size.value) return "";
  return size.unit === "unitless" ? size.value : `${size.value}${size.unit}`;
}
